"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Waiting = _interopRequireDefault(require("./Waiting"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Loading(_ref) {
  var isLoading = _ref.isLoading,
    _ref$objectType = _ref.objectType,
    objectType = _ref$objectType === void 0 ? '' : _ref$objectType;
  return /*#__PURE__*/_react.default.createElement(_Waiting.default, {
    isLoading: isLoading,
    message: "Loading ".concat(objectType, "...")
  });
}
Loading.propTypes = {
  isLoading: _propTypes.default.bool.isRequired,
  objectType: _propTypes.default.string
};